import customerIndex from './pages/CustomerIndex.vue'
import addNewCustomer from './pages/AddNewCustomer.vue'
import carSearchIndex from './pages/CarSearchIndex.vue'
import enquiteIndex from './pages/EnquiteIndex.vue'
import prView from './pages/PrView.vue'



const routers = [
    {
        path: '/customerIndex/:shopId?',
        name: 'customerIndex',
        component: customerIndex
    },
    {
        path: '/addNewCustomer',
        name: 'addNewCustomer',
        component: addNewCustomer
    },
    {
        path: '/carSearchIndex/:customerId',
        name: 'carSearchIndex',
        component: carSearchIndex
    },
    {
        path: '/enquiteIndex/:customerId/:type/:carId?',
        name: 'enquiteIndex',
        component: enquiteIndex
    },
    {
        path: '/pr',
        name: 'pr',
        component: prView
    },
    {
        path: '/:shopId?',
        component: customerIndex
    },
]

export default routers
